import { render, staticRenderFns } from "./Vouchers_list.vue?vue&type=template&id=6147674c&scoped=true&"
import script from "./Vouchers_list.vue?vue&type=script&lang=js&"
export * from "./Vouchers_list.vue?vue&type=script&lang=js&"
import style0 from "./Vouchers_list.vue?vue&type=style&index=0&id=6147674c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6147674c",
  null
  
)

export default component.exports